<template>
  <p v-if="loading" style="text-align: center;padding: 20px">
      <span style="font-size: 25px;">
          <i class="fa fa-spinner fa-spin"></i> Loading...
      </span>
  </p>
  <b-row v-else>
    <b-col cols="6" xl="6" sm="12">
      <transition name="slide">
        <b-card>
            <div slot="header" v-html="caption"></div>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="roles" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
              <template slot="S/N" slot-scope="data">
                <strong>{{data.item.id}}</strong>
              </template>
              <template slot="name" slot-scope="data">
                <strong>{{data.item.name.toUpperCase()}}</strong>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(roles)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { baseURL } from '@/shared/utils'

export default {
  name: 'Roles',
  props: {
    caption: {
      type: String,
      default: 'Roles and Permission'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {key: 'S/N'},
        {key: 'name'},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      first_name: '',
      last_name: '',
      email: '',
      roles: [],
      loading: false
    }
  },
  computed: {
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get(`${baseURL}roles`)
      .then(({data}) => {
        console.log(data);
        this.loading = false;
        this.roles = data.datas;
      })
      .catch(function (error) {
        this.loading = false;
        console.log(error);
      });
    },
    getRowCount () {
      return this.roles.length
    },
    userLink (id) {
      return `roles-permissions/${id.toString()}`
    },
    rowClicked (item) {
      const userLink = this.userLink(item.id)
      this.$router.push({path: userLink})
    }
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
